import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "@shared/services/auth.service";
import { catchError, Observable, of, throwError } from "rxjs";

@Injectable()
export class EnabledClientInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(req).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 403 && error.error.code === 'E_DISABLED_CLIENT') {
              this.authService.logout(true);
          }
        }
        return throwError(() => error);
      })
    );
  }
}